import { useNavigate } from 'react-router';

import { OneColumn } from 'components/page';
import { useApplicationContext } from 'context/ApplicationContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { DreGrid, DreGridFilter, DreReport } from 'pages/financeiro/dre/components';

export function DreListComp() {
    const navigate = useNavigate();
    const { hasPermission } = usePermissionsContext();
    const { user } = useApplicationContext();

    return (
        <OneColumn
            title="Estimativa de Resultado"
            extraButtons={[
                {
                    title: 'Gerenciar preenchimentos de estimativa de resultado',
                    visible: hasPermission(['FINANCEIRO_DRE_PREENCHIMENTO_GERENCIAR']),
                    onClick: () => navigate('preenchimento'),
                },
                {
                    title: 'Configurar estimativa de resultado',
                    visible: user.tipoUsuario.tipoUsuarioEnum === 'SUPORTE_CISS',
                    onClick: () => navigate('configuracao'),
                },
            ]}
        >
            <DreGridFilter />

            <DreReport />

            <DreGrid />
        </OneColumn>
    );
}
